import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Injectable({ providedIn: 'root' })
@Pipe({
    name: 'httpLink',
})
export class HttpLinkPipe implements PipeTransform {
    transform(value: string): string {
        const hrefList = value.match(new RegExp(/href=".*?"/, 'g'));
        hrefList?.forEach((href) => {
            let url = href.substring(6, href.length - 1);
            if (!url.match(/^[a-zA-Z]+:/)) {
                url = 'http://' + url;
            }
            let newHref;
            if (
                !value.includes('target="_blank"') &&
                !value.includes("target='_blank'") &&
                !url.startsWith('mailto:')
            ) {
                newHref = 'href="' + url + '" target="_blank"';
            } else {
                newHref = 'href="' + url + '"';
            }
            value = value.replace(href, newHref);
        });

        return value;
    }
}
